import { DialogBody } from "@blueprintjs/core";
import React from "react";

import { Button, Modal } from "../../../../components";
import { Playbook } from "../../../../types/playbook/playbook";
import styles from "./dialogs.module.scss";

interface DeletePlaybookDialogProps {
  show: boolean;
  handleClose: (e: any) => void;
  playbook: Playbook;
  handleDeletePlaybook: (e: any) => void;
}

const DeletePlaybookDialog = ({ show, handleClose, playbook, handleDeletePlaybook }: DeletePlaybookDialogProps) => {
  return (
    <Modal
      title="Delete Playbook"
      isOpen={show}
      onClose={handleClose}
      actions={[
        <Button minimal={true} text="Cancel" onClick={handleClose} key={2} />,
        <Button intent="danger" text="Delete" onClick={handleDeletePlaybook} key={1} />,
      ]}
    >
      <DialogBody>
        <div>
          Are you sure you want to delete playbook <span className={styles.title}>{playbook.title}</span>?
        </div>
      </DialogBody>
    </Modal>
  );
};

export default DeletePlaybookDialog;
